import React, {useEffect, useRef, useState} from "react";
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {AppBar, Dialog, DialogContent, Divider, Grid, InputAdornment, TextField} from "@material-ui/core";
import {useDispatch, useSelector} from "../../store";
import {selectApplets, selectUserInfo, setUserInfo} from "../../reducer/iam/authReducer";
import {useHistory, useRouteMatch} from "react-router-dom";
import Button from "../../lib/appfuse-react/component/Button";
import Space from "../../lib/appfuse-react/component/Space";
import Typography from "@material-ui/core/Typography";
import SearchField from "../../component/SearchField";
import Expander from "../../lib/appfuse-react/component/Expander";
import Toolbar from "../../component/Toolbar";
import UserProfile from "./UserProfile";
import lang from "../../lib/appfuse-react/core/lang";
import {selectTitle} from "../../reducer/app/appReducer";
import i18n from "../../lib/appfuse-react/core/i18n";
import Dock, {DockItem} from "../../lib/appfuse-react/component/Dock";
import Box from "../../lib/appfuse-react/component/Box";
import env from "../../lib/appfuse-react/core/env";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import Image from "../../lib/appfuse-react/component/Image";
import authService from "../../service/iam/authService";
import {ReactComponent as LatestNewsIcon} from "../../image/latest-news.svg";
import LatestNews from "../../applet/LatestNews";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import Form from "../../lib/appfuse-react/component/Form";
import RouteButton from "../../component/RouteButton";
import organizationService from "../../service/organization/organizationService";
import IconButton from "@material-ui/core/IconButton";
import {
    AccountCircle, Close, Mail, Notifications, Save, Visibility, VisibilityOff
} from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";
import DrawerMenu from "../../component/AppletMenu/DrawerMenu";

const DEFAULTICON = 'image/application/webpage.svg';

const initialContext = {
    workspace: undefined
}

const DesktopContext = React.createContext(initialContext);


const useStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 100,
        backgroundColor: theme.brand.appbar?.backgroundColor,
        color: theme.brand.appbar?.color,
    }
}));

function isEmptyRichText(data) {
    return lang.isEmpty(data) || (lang.isString(data) && data === '{"type":"rtx","children":[{"type":"paragraph","children":[{"text":""}]}]}');
}

function Desktop(props) {
    const prompt = usePrompt();
    const theme = useTheme();
    const router = useRouter();
    const backgroundImage = router.resolve(theme.brand.backgroundImage);
    const classes = useStyles({backgroundImage});
    const history = useHistory();
    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState(null);
    const [userProfileAnchorEl, setUserProfileAnchorEl] = useState(null);
    const [changePasswordOpen, setChangePasswordOpen] = useState(false);
    const { path } = useRouteMatch();
    const title = useSelector(selectTitle);
    const userInfo = useSelector(selectUserInfo);
    const applets = useSelector(selectApplets);
    const responsive = env.responsive;
    const getResponsive = useResponsive();
    const workspaceRef = useRef();
    const workspace = workspaceRef?.current;

    const [showChangePassword, setShowChangePassword] = useState(false);
    const location = props.children.props.location;
    const {search} = location || {};
    const urlParams = new URLSearchParams(search);
    const changePassword = urlParams.get("changePasscode");
    if (lang.isNotEmpty(changePassword) && changePassword==="true" && lang.isFalse(showChangePassword)) {
        setChangePasswordOpen(true);
        setShowChangePassword(true);
    }

    useEffect(() => {
        (async () => {
            await getUserInfo();
        })();
    }, []);

    const getUserInfo = async () => {
        try {
            const userInfo = await authService.fetchUserInfo();
            dispatch(setUserInfo(userInfo));
            const {userType} = userInfo;
            if(!userType) await noPermission();
        } catch (e) {
            await noPermission();
        }
    };

    const noPermission = async () => {
        await authService.logout();
        history.push('/logon');
        prompt.alert('No Permission');
    };

    const handleDockItemClick = (event) => {
        const { value } = event;
        history.push(`/${value}`);
    };

    const handleToggleUserProfile = (event) => {
        setUserProfileAnchorEl(userProfileAnchorEl ? null : event.currentTarget);
    };

    const handleUserProfileClose = () => {
        setUserProfileAnchorEl(null);
    }

    const handleChangePasswordOpen = () => setChangePasswordOpen(true);
    const handleChangePasswordClose = () => setChangePasswordOpen(false);
    const handleChangePassword = async (value) => {
        await authService.changePassword(value);
    };

    const handleLogout = () => {
        setUserProfileAnchorEl(null);
        authService.logout();
        router.reload();
    }

    const handleSearch = event => {
        const keyword = event.value;
        setKeyword(keyword);
    }

    window.document.title = i18n.translate(title);

    const dockItems = applets.map(applet => {
        const { id, path, text = 'Unknown', icon = DEFAULTICON, locked, disabled, badge, description } = applet;

        return (
            <DockItem key={id} icon={icon} text={text} description={description} locked={locked} disabled={disabled} badge={badge} value={path}
                      onClick={handleDockItemClick}/>
        )
    });

    const settings = env.get('app');

    // 組織
    const [organization, setOrganization] = useState({});
    const [menuOpen, setMenuOpen] = useState(false);
    // 最新消息
    const latestNewsRef = useRef(null);
    const [latestNewsOpen, setLatestNewsOpen] = useState(false);
    const handleLatestNewsOpen = () => setLatestNewsOpen(true);
    const handleLatestNewsClose = () => setLatestNewsOpen(false);

    useEffect(() => {
        (async () => {
            let latestNews = organization?.latestNews;
            if(lang.isEmpty(organization)) {
                const organization = await organizationService.get();
                setOrganization(organization);
                latestNews = organization?.latestNews;
            }
            const userInfo = await authService.fetchUserInfo();
            const {defaultApplet} = userInfo;
            // if (defaultApplet === 'satisfactionSurvey' || defaultApplet === 'courseAnnouncement') {
            //     if (((defaultApplet === 'satisfactionSurvey' && path === '/satisfactionSurvey') || (defaultApplet === 'courseAnnouncement' && path === '/courseAnnouncement')) && lang.isNotNullOrUndefined(latestNews) && lang.isNotEmpty(latestNews) && !isEmptyRichText(latestNews)) {
            //         setLatestNewsOpen(true);
            //     }
            // } else
                if((path==='/' || path==='/main') && lang.isNotNullOrUndefined(latestNews) && lang.isNotEmpty(latestNews) && !isEmptyRichText(latestNews)) {
                setLatestNewsOpen(true);
            }
        })();
    }, [path]);

    const stageInfo = env.appStage.toUpperCase() === 'PROD' ? null : env.appStage;
    const versionInfo = env.appVersion + `${stageInfo ? '@' + stageInfo: ''}`;

    const bigScreen = getResponsive.isLargeScreen() || getResponsive.isMediumScreen();

    const handleMenu = () => {
        setMenuOpen(!menuOpen);
    }

    return (
        <Box className="app-desktop" fullWidth fullHeight overflow="hidden" display="flex" flexDirection="column">
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Image value={theme.brand.logo} onClick={()=> history.push('/main')} height={36} title={versionInfo} />
                    <Space spacing={1} />
                    {bigScreen ? <Typography variant="h5" noWrap>
                        {i18n.translate(title)}
                        <Space spacing={1} />
                        {stageInfo ? <Typography variant="body2" display="inline">{versionInfo}</Typography> : null}
                    </Typography> : <Typography variant="h6" noWrap></Typography>}
                    <Box display={lang.isFalse(settings.search) ? 'none' : 'initial'}>
                        <SearchField label="Search" value={keyword} onChange={handleSearch} />
                    </Box>
                    <Box paddingX={2}>
                        <Button icon={<LatestNewsIcon/>} variant='text' text={bigScreen?"Latest News":""} color='inherit' ref={latestNewsRef} onClick={handleLatestNewsOpen}/>
                        {latestNewsOpen && <LatestNews open={latestNewsOpen} anchorEl={latestNewsRef} data={organization?.latestNews} onClose={handleLatestNewsClose}/>}
                    </Box>
                    <Expander />
                    {bigScreen ? <React.Fragment>
                        <RouteButton text="Course announcement" route='/courseAnnouncement' path={path}/>
                        <RouteButton text="Course Fee" route='/courseFee' path={path}/>
                        <RouteButton text="Course Brief" route='/courseBrief' path={path}/>
                        <RouteButton text="Contact Us" route='/contactUs' path={path}/>
                        <RouteButton text="Traffic Information" route='/trafficInfo' path={path}/>
                        <RouteButton text="Other Information" route='/otherInfo' path={path}/>
                        <Divider orientation='vertical' variant='middle' style={{backgroundColor: 'rgba(255, 255, 255, 0.7)', height: '50%'}}/>
                        <Typography variant="subtitle1" noWrap>{`${i18n.translate('Welcome')} ${userInfo?.name || ''}`}</Typography>
                    </React.Fragment> : <Box>
                        <IconButton color="inherit" onClick={handleMenu}>
                            <MenuIcon />
                        </IconButton>
                    </Box>}
                    <Space spacing={2} />
                    {/*<Button icon={<Mail/>} variant="icon" badge={12}  color="inherit" />*/}
                    {/*<Button icon={<Notifications/>} variant="icon" badge={4}  color="inherit" />*/}
                    <Button icon={<AccountCircle/>} variant="icon"  color="inherit" onClick={handleToggleUserProfile} />
                </Toolbar>
            </AppBar>
            <DrawerMenu open={menuOpen} onClose={handleMenu}/>
            <Box fullHeight fullWidth backgroundImage={backgroundImage} display="flex" overflow="hidden">
                <Box fullHeight fullWidth flexGrow={1} overflow="auto">
                    <Box ref={workspaceRef} fullHeight fullWidth overflow="hidden" minWidth={`${responsive.minWidth}px`}>
                        <DesktopContext.Provider value={{workspace}}>
                            {props.children}
                        </DesktopContext.Provider>
                    </Box>
                </Box>
                {bigScreen && <Dock translucent defaultExpanded>{dockItems}</Dock>}
            </Box>
            <UserProfile anchorEl={userProfileAnchorEl} userInfo={userInfo}
                         open={lang.isNotNullOrUndefined(userProfileAnchorEl)}
                         onClose={handleUserProfileClose} onChangePassword={handleChangePasswordOpen} onLogout={handleLogout}/>
            {changePasswordOpen && <ChangePassword open={changePasswordOpen} onClose={handleChangePasswordClose} onApply={handleChangePassword}/>}
        </Box>
    )
}

const withDesktop = WrappedComponent => (props) => {
    return (
        <Desktop>
            <WrappedComponent {...props} />
        </Desktop>
    );
};

function ChangePassword(props) {
    const prompt = usePrompt();
    const {open} = props;
    const [value, setValue] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const handleChange = (event) => {
        const {value} = event;
        setValue(value);
    };

    const handleOK = async () => {
        if(lang.isEmpty(value?.newPassword)) {
            prompt.confirm('Please enter the new password.');
            return;
        } else if(lang.isEmpty(value?.confirmNewPassword)) {
            prompt.confirm('Please enter the new password again.');
            return;
        }
        try {
            await props.onApply(value);
            prompt.success('Password changed successfully.');
            props.onClose();
        } catch (e) {
            prompt.alert(e, {title: 'Failed to change password.'});
        }
    };

    return (
        <Dialog open={open} onClose={props.onClose} maxWidth='xs' fullWidth>
            <Box paddingTop={2}>
                <Typography align='center' variant='h6'>{i18n.translate('Change Password')}</Typography>
            </Box>
            <Divider variant='middle'/>
            <DialogContent>
                <Box fullHeight fullWidth overflow='auto' paddingTop={2} paddingBottom={5} paddingX={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Form value={value} onChange={handleChange} onSubmit={handleOK}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant='caption' color='textSecondary'>{i18n.translate('Please contain at least 8 characters, including English uppercase and lowercase letters, numbers and symbols')}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/*新密碼*/}
                                        <TextField
                                            name='newPassword'
                                            label='Please enter the new password.'
                                            variant='outlined'
                                            fullWidth
                                            required
                                            type={showPassword? "text" : "password"}
                                            autoComplete="current-password"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={handleShowPassword}>
                                                            { showPassword? <Visibility/> : <VisibilityOff/> }
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/*確認新密碼*/}
                                        <TextField
                                            name='confirmNewPassword'
                                            label='Enter the new password again.'
                                            variant='outlined'
                                            fullWidth
                                            required
                                            type={showConfirmPassword? "text" : "password"}
                                            autoComplete="current-password"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={handleShowConfirmPassword}>
                                                            { showConfirmPassword? <Visibility/> : <VisibilityOff/> }
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}/>
                                    </Grid>
                                </Grid>
                            </Form>
                        </Grid>
                        <Grid item xs={6}>
                            <Button startIcon={<Save/>} text='OK' variant='contained' color='primary' fullWidth onClick={handleOK}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button startIcon={<Close/>} text='Cancel' variant='contained' color='primary' fullWidth onClick={props.onClose}/>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default Desktop;

export { withDesktop, DesktopContext, isEmptyRichText };